import React from 'react'
import { Col, Row, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

import { AssignTree } from 'src/types'
import { Tree } from 'src/components/Tree'
import * as PoliciesTreeService from 'src/services/api/policies-trees'

import * as CSS from './styles'

import { PropsTreeSelected } from '../..'
import { SelectNodeProps } from '../hierarchy-flows-chained'

interface Props {
  toggle(
    node?: Pick<AssignTree, 'assign_tree_id' | 'color' | 'disabled'>[]
  ): void
  valuedNodes: SelectNodeProps[]
  refetch?: (policy_name: 'approval' | 'conference') => void
  policy_name?: 'approval' | 'conference'
}

export default function HierarchyTreeSelectModal({
  toggle,
  valuedNodes,
  refetch
}: Props) {
  const { t } = useTranslation()

  function setTreeSelected(treeSelected: PropsTreeSelected) {
    const found = valuedNodes.some(
      node => `${node.assign_tree_id}` === `${treeSelected.id}`
    )
    const value2 =
      valuedNodes.find(node => node.disabled)?.assign_tree_name || ''

    let content
    if (found) {
      content = t('web.policies-flow.tree-modal-chain.exclude', {
        value1: treeSelected?.name || '',
        value2
      })
    } else {
      content = t('web.policies-flow.tree-modal-chain.include', {
        value1: treeSelected?.name || '',
        value2
      })
    }

    const cancelText = t('common.actions.cancel')
    const okText = t('common.actions.yes')

    Modal.confirm({
      cancelText,
      content,
      okText,
      onCancel: () => {},
      onOk: () => {
        if (found) {
          PoliciesTreeService.saveChained({
            assign_tree_id: valuedNodes[0].assign_tree_id,
            chained_assign_tree_id: treeSelected.id,
            policy_name: valuedNodes[0].policy_name,
            method: 'remove'
          }).then(() => {
            refetch(valuedNodes[0].policy_name)
          })
        } else {
          PoliciesTreeService.saveChained({
            assign_tree_id: valuedNodes[0].assign_tree_id,
            chained_assign_tree_id: treeSelected.id,
            policy_name: valuedNodes[0].policy_name,
            method: 'save'
          }).then(() => {
            refetch(valuedNodes[0].policy_name)
          })
        }
      },
      title: t('web.policies-flow.tree-modal-chain.sure')
    })
  }

  return (
    <Modal
      centered
      closable
      destroyOnClose
      okButtonProps={{
        hidden: true,
        //@ts-ignore
        'data-test-id': 'hierarchy-flows-approvals-exception'
      }}
      onCancel={() => {
        toggle()
      }}
      // onOk={() => {}}
      title={t('web.policies-flow.tree-modal-chain.title')}
      visible={Boolean(valuedNodes?.length)}
      width={800}
    >
      <Row>
        <CSS.Col>
          <CSS.Icon1 />
          {t('web.policies-flow.tree-modal-chain.subtitle1')}
        </CSS.Col>
        <CSS.Col>
          <CSS.Icon2 />
          {t('web.policies-flow.tree-modal-chain.subtitle2')}
        </CSS.Col>
        <CSS.Col>
          <CSS.Icon3 />
          {t('web.policies-flow.tree-modal-chain.subtitle3')}
        </CSS.Col>
      </Row>
      <Row>
        <CSS.Col>
          <CSS.TextInfo>
            {t('web.policies-flow.tree-modal-chain.info')}
          </CSS.TextInfo>
        </CSS.Col>
      </Row>
      <Row>
        <Col span={24}>
          <CSS.Title>
            {t('web.policies-flow.tree-modal-chain.chain-structure')}
          </CSS.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Tree setTreeSelected={setTreeSelected} valuedNodes={valuedNodes} />
        </Col>
      </Row>
    </Modal>
  )
}
